import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import { useModel, useModelKey, useValue } from '@morningtrain/react-resources'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'
import SupplierCategorySmartview from 'widgets/smartviews/inventory/SupplierCategorySmartview'
import Button from 'ui/buttons/Button'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'

export default function SupplierCategoryButton () {
  const supplierCategoryId = useModelKey()
  const categoryName = useValue('name')

  if (!supplierCategoryId) {
    return null
  }

  const shouldRender = (value) => {
    return value !== null
  }

  return (
    <WhenEnvValueMatches name={['globals.inventory.supplier_categories', supplierCategoryId].join('.')} matches={shouldRender}>
      <MountSmartviewWithModelOnClick
        smartview={<SupplierCategorySmartview categoryId={supplierCategoryId} categoryName={categoryName} />}
      >
        <Button color='outlineDark'>
          <Displays.Text name='name' />
        </Button>
      </MountSmartviewWithModelOnClick>
    </WhenEnvValueMatches>
  )
}
